import { render } from "./FullTestPanel.vue?vue&type=template&id=aac9cc7a&scoped=true"
import script from "./FullTestPanel.vue?vue&type=script&lang=js"
export * from "./FullTestPanel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmattern/Documents/3 - GIT/studio-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aac9cc7a"]])

export default __exports__